// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Listings {

}

.Listings .sort-select-wrapper {
  text-align: center;
  display: flex;
  font-family: serif;
  flex-direction: column;
}

.Listings .sort-select-wrapper .select-label {
  padding-right: 1em;
  font-family: serif;
}

.Listings .sort-select-wrapper select {
  font-size: 14pt;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Listings.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".Listings {\n\n}\n\n.Listings .sort-select-wrapper {\n  text-align: center;\n  display: flex;\n  font-family: serif;\n  flex-direction: column;\n}\n\n.Listings .sort-select-wrapper .select-label {\n  padding-right: 1em;\n  font-family: serif;\n}\n\n.Listings .sort-select-wrapper select {\n  font-size: 14pt;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
